import { render, staticRenderFns } from "./NavbarNotification.vue?vue&type=template&id=6137cfdb&scoped=true"
import script from "./NavbarNotification.vue?vue&type=script&lang=js"
export * from "./NavbarNotification.vue?vue&type=script&lang=js"
import style0 from "./NavbarNotification.vue?vue&type=style&index=0&id=6137cfdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6137cfdb",
  null
  
)

export default component.exports